import React from 'react';
import styled from 'styled-components';
import { OutlinedInput } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(() => ({
    input: {
        padding: '10px 14px',
    },
}));
const Input = (props) => {
    const classes = useStyles();
    return React.createElement(OutlinedInput, Object.assign({ classes: classes, type: "email" }, props));
};
Input.displayName = 'Newsletter.Input';
const InputExtra = styled(Input) ``;
export default InputExtra;
